import React, { PureComponent } from "react";

import _ from "i18n";

import GroupsSelect from "./GroupsSelect";
import styles from "./Tooltip.local.scss";

export default class Tooltip extends PureComponent {
  handleChange = event => {
    const {
      checkedItems,
      selectedGroups,
      setCheckedItems,
      setSelectedGroups
    } = this.props;
    setCheckedItems(event.target.name, event.target.checked);

    if (
      (event.target.name === "ALL" && event.target.checked) ||
      (event.target.name === "GROUP" && !event.target.checked)
    ) {
      setSelectedGroups([]);
    }
  };

  //   let checked = {
  //     CLIENT_SHARE: false,
  //     MEMBER_SHARE: false,
  //     INTRA_SHARE: false,
  //     GROUP_SHARE: false
  //   };

  // const groups =
  //     article?.groups && article.groups !== "" ? article.groups : [];
  // const [checkedItems, setCheckedItems] = useState(checked);
  // const [selectedGroups, setSelectedGroups] = useState(groups);
  render() {
    const {
      checkedItems,
      selectedGroups,
      setSelectedGroups,
      auth
    } = this.props;
    return (
      <div className={styles.container} onClick={e => e.stopPropagation()}>
        <div className={styles.share__btn}>
          <span className={styles.title}>{_("configure_for")}:</span>
          <ul>
            <li>
              <label>
                <input
                  name="ALL"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={checkedItems.includes("ALL")}
                />
                &nbsp; {_("all")}
              </label>
            </li>
            <li>
              <label>
                <input
                  name="CLIENT"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={checkedItems.includes("CLIENT")}
                />
                &nbsp; {_("clients")}
              </label>
            </li>
            <li>
              <label>
                <input
                  name="COLLABORATER"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={checkedItems.includes("COLLABORATER")}
                />
                &nbsp; {_("collaborators")}
              </label>
            </li>
            <li>
              <label>
                <input
                  name="MEMBER"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={checkedItems.includes("MEMBER")}
                  disabled={checkedItems.includes("GROUP")}
                />
                &nbsp; {_("member")}
              </label>
            </li>
            <li>
              <label>
                <input
                  name="GROUP"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={checkedItems.includes("GROUP")}
                  disabled={checkedItems.includes("MEMBER")}
                />
                &nbsp; {_("groupes")}
              </label>
            </li>
          </ul>
          {checkedItems.includes("GROUP") && (
            <GroupsSelect
              isMulti={true}
              selectedGroups={selectedGroups}
              onChange={setSelectedGroups}
              auth={auth}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Settings/Tooltip.js